export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
  imageUrl: string;
  articleCount: number;
}

export const categories: Category[] = [
  {
    slug: 'night-life',
    name: '夜间生活',
    description: '探索城市夜晚的无限可能，从深夜食堂到霓虹街头，记录夜幕下最真实的城市脉动。',
    icon: 'ri-moon-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20urban%20cityscape%20at%20night%20with%20warm%20neon%20lights%2C%20quiet%20streets%20with%20streetlamps%2C%20atmospheric%20nighttime%20urban%20photography%2C%20moody%20and%20cinematic%20composition%2C%20deep%20shadows%20with%20warm%20amber%20highlights%2C%20no%20people%2C%20minimal%20composition&width=800&height=500&seq=cat-night-life&orientation=landscape',
    articleCount: 12,
  },
  {
    slug: 'creative-inspiration',
    name: '创作灵感',
    description: '黑夜是灵感的温床，在万籁俱寂时捕捉最闪光的创意火花，让夜晚成为创作的最佳时刻。',
    icon: 'ri-lightbulb-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20artistic%20studio%20at%20night%20with%20warm%20desk%20lamp%20lighting%2C%20sketchbook%20and%20paintbrushes%20on%20wooden%20table%2C%20moody%20atmospheric%20creative%20workspace%2C%20deep%20shadows%20with%20warm%20golden%20light%20accents%2C%20cinematic%20composition%2C%20no%20people&width=800&height=500&seq=cat-creative&orientation=landscape',
    articleCount: 8,
  },
  {
    slug: 'late-night-emotion',
    name: '深夜情绪',
    description: '当世界安静下来，内心的声音变得更加清晰。这里收录每一个深夜里的真实情感与思考。',
    icon: 'ri-heart-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20moody%20night%20scene%20through%20rainy%20window%2C%20warm%20interior%20light%20reflection%2C%20atmospheric%20emotional%20photography%2C%20deep%20shadows%20with%20soft%20amber%20glow%2C%20cinematic%20mood%2C%20contemplative%20nocturnal%20atmosphere%2C%20no%20people&width=800&height=500&seq=cat-emotion&orientation=landscape',
    articleCount: 15,
  },
  {
    slug: 'night-walker-community',
    name: '夜行者社群',
    description: '每一个夜行者都不孤单。这里汇聚了热爱夜晚的人们，分享故事、彼此陪伴、共同前行。',
    icon: 'ri-group-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20warm%20cozy%20gathering%20at%20night%20with%20fairy%20lights%2C%20outdoor%20evening%20community%20space%2C%20atmospheric%20nighttime%20social%20scene%2C%20deep%20shadows%20with%20warm%20amber%20and%20golden%20lighting%2C%20cinematic%20composition%2C%20no%20faces%20visible&width=800&height=500&seq=cat-community&orientation=landscape',
    articleCount: 10,
  },
];